export const HTTP_STATUS_REDIRECT = 310
